import React, { useState } from 'react';

const ActionConfirmationModal = ({ isOpen, onClose, onSubmit, title, actionType, actionLoading }) => {
  const [comments, setComments] = useState('');
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!comments.trim()) {
      setError('Please provide a reason/comment.');
      return;
    }
    setError('');
    onSubmit(comments);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-lg border border-slate-200 shadow-xl w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
          <h3 className="text-[16px] font-semibold text-slate-700">{title}</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600 text-xl leading-none">×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="p-5 space-y-4">
            <div className="text-[13px] text-slate-600">
              Are you sure you want to <span className="font-semibold text-slate-800 capitalize">{actionType}</span> this request? Please provide a reason below.
            </div>
            <div>
              <label className="block text-[12px] font-medium text-slate-600 mb-1">Reason / Comments *</label>
              <textarea
                value={comments}
                onChange={(e) => setComments(e.target.value)}
                rows={3}
                className="w-full px-3 py-2 text-[12px] border border-slate-300 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500"
                placeholder={`Enter reason for ${actionType}...`}
              />
              {error && <p className="text-rose-500 text-[11px] mt-1">{error}</p>}
            </div>
          </div>
          <div className="px-5 py-3 border-t border-slate-100 flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-3 py-1.5 text-[12px] border border-slate-300 text-slate-600 rounded hover:bg-slate-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={actionLoading}
              className={`px-3 py-1.5 text-[12px] text-white rounded font-medium ${
                actionType === 'approve' ? 'bg-emerald-600 hover:bg-emerald-700' : 'bg-rose-600 hover:bg-rose-700'
              } disabled:opacity-50`}
            >
              {actionLoading ? 'Processing...' : actionType === 'approve' ? 'Approve' : 'Reject'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ActionConfirmationModal;
